const isRouteCurrentlyActive = function(route: string | undefined): boolean {
  return (
    route != null &&
    window.location.href.toLowerCase().includes(route.toLowerCase())
  );
};

const withoutTrailingSlash = function(path: string): string {
  const lowerCasePath = path.toLowerCase();

  return lowerCasePath.length > 1 && lowerCasePath.endsWith("/")
    ? lowerCasePath.slice(0, -1)
    : lowerCasePath;
};

/*
 * Matches the current path in full. Use this for menu items whose route is a complete path, because one route can be
 * the start of another (e.g. rent-control and rent-control-types) and isRouteCurrentlyActive would match both.
 */
const isRouteExactlyActive = function(route: string | undefined): boolean {
  return (
    route != null &&
    withoutTrailingSlash(window.location.pathname) === withoutTrailingSlash(route)
  );
};

const locationUtils = {
  isRouteCurrentlyActive,
  isRouteExactlyActive
};
export default locationUtils;
